<div class="mx-auto my-10 w-full px-3 text-center">
  <img alt="Profile Image" class="border-1 mx-auto h-40 w-40 rounded-full border-solid drop-shadow-md" [src]="profileImageUrl" />
  <h1 class="mt-10 text-center text-3xl font-bold" [innerHtml]="heading"></h1>
  <p class="mb-10 text-steel-70">{{ subheading }}</p>

  <button
    type="button"
    class="mt-3 w-full sm:mr-auto sm:w-48"
    [disabled]="pending"
    (click)="onActivateProfile()"
    mat-flat-button
    color="primary"
  >
    @if (pending) {
      <mat-spinner diameter="25" />
    }
    @if (pending === false) {
      <span>{{ cta }}</span>
    }
  </button>

  <p class="mt-3 text-steel-70" [innerHtml]="termsConditions"></p>
</div>
